var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03378 5.71764V9.60824C7.03378 9.82389 6.87489 10 6.68033 10H5.26657C5.07201 10 4.91313 9.82389 4.91313 9.60824V5.71764H3.35344C3.15889 5.71764 3 5.54333 3 5.32588C3 5.22165 3.03729 5.12102 3.10376 5.04734L5.75133 2.11456C5.88914 1.96181 6.11288 1.96181 6.25069 2.11456L8.89664 5.04914C9.03445 5.20189 9.03445 5.44988 8.89664 5.60263C8.83017 5.67631 8.73938 5.71764 8.64534 5.71764H7.03378Z",
    fill: "#009B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.e1276d12f0f725cb3e994fde5908bc60.svg";
export { ForwardRef as ReactComponent };